import type { ButtonProps } from './types';

const COLLAPSE_LABEL_CLASS: Record<NonNullable<ButtonProps['collapseLabel']>, string> = {
  mobile: 'sr-only sm:not-sr-only',
  desktop: 'sm:sr-only',
};

/** Hides the text visually, so a button standing on its icon keeps its accessible name. */
export function collapsedLabelClass(collapseLabel: ButtonProps['collapseLabel']) {
  return collapseLabel ? COLLAPSE_LABEL_CLASS[collapseLabel] : undefined;
}
